exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.imagen {\n  display: block;\n  width: 600px;\n  height: 400px;\n  -o-object-fit: cover;\n     object-fit: cover;\n  margin: 0 auto;\n  border-radius: 4px;\n  -webkit-box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);\n}\n", ""]);

// exports
